import { render, staticRenderFns } from "./BaseButtonIcon.vue?vue&type=template&id=1f9aab48&scoped=true&"
import script from "./BaseButtonIcon.vue?vue&type=script&lang=js&"
export * from "./BaseButtonIcon.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonIcon.vue?vue&type=style&index=0&id=1f9aab48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9aab48",
  null
  
)

export default component.exports